export function useCasts()
{
    function toNumber(val): number {
        let numeric = Number(val);
        return Number.isNaN(numeric) ? 0 : numeric;
    }

    return {
        toNumber
    }
}